import React, { useEffect } from 'react';
import SEO from '../components/SEO';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import './MotDirecteur.css';

// Import de la photo du directeur
import directorImg from '../assets/directeur-mrics.jpg';

const MotDirecteur = () => {
  
  // Scroll to top
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <SEO
        title="Mot du Directeur — Salah Eddine El Kacimi MRICS | ATAA REALTY"
        description="Mot du Directeur Salah Eddine EL KACIMI, MRICS — Expert Immobilier MRICS, Ingénieur Topographe (IAV Hassan II), Mastère en Droit & Fiscalité (ISCAE). Engagement, vision et leadership chez ATAA REALTY."
        canonical="https://ataarealty.com/mot-directeur"
        keywords="Salah Eddine El Kacimi, expert MRICS Maroc, directeur ATAA Realty, IAV Hassan II, ISCAE, expert immobilier RICS Casablanca"
        jsonLd={{
          '@context': 'https://schema.org',
          '@type': 'Person',
          name: 'Salah Eddine El Kacimi',
          honorificSuffix: 'MRICS',
          jobTitle: 'Expert Immobilier MRICS, Directeur',
          worksFor: { '@type': 'ProfessionalService', name: 'ATAA REALTY', url: 'https://ataarealty.com/' },
          alumniOf: [
            { '@type': 'EducationalOrganization', name: 'IAV Hassan II — Rabat' },
            { '@type': 'EducationalOrganization', name: 'ISCAE — Casablanca' }
          ],
          url: 'https://ataarealty.com/mot-directeur'
        }}
      />
      <Navbar />

      {/* Header */}
      <header className="director-header">
        <div className="director-overlay"></div>
        <div className="director-title-box anim-up">
          <span className="director-subtitle">LEADERSHIP & ENGAGEMENT</span>
          <h1>MOT DU DIRECTEUR</h1>
        </div>
      </header>

      {/* Contenu */}
      <section className="director-content-section">
        <div className="container">
          <div className="director-grid">
            
            {/* Colonne Gauche : Texte */}
            <div className="director-text-col">
              
              {/* Citation */}
              <blockquote className="big-quote anim-up delay-1">
                “ Que notre société satisfasse le sens profond de son nom " ATAA " dans ses prestations et collaborations ”
              </blockquote>
              
              <p className="anim-up delay-2">
                Dans un environnement immobilier où les décisions engagent durablement le patrimoine, le capital et la confiance, <strong>ATAA REALTY</strong> s’inscrit dans une démarche fondée sur la clarté de l’analyse et la justesse de la recommandation.
              </p>

              <p className="anim-up delay-2">
                Chaque mission est abordée comme un exercice de responsabilité professionnelle, visant à apporter une lecture structurée des actifs, des risques et des opportunités, au service d’une prise de décision éclairée et maîtrisée.
              </p>

              <p className="anim-up delay-3">
                À travers ce cabinet, j’ai souhaité instaurer une relation fondée sur la continuité, la pédagogie et le respect des enjeux propres à chaque client, qu’il s’agisse d’acteurs publics, d’institutions financières et bancaires, d’investisseurs, de promoteurs et d’opérateurs immobiliers, d’entreprises, ou encore de particuliers engagés dans des projets à forte dimension patrimoniale.
              </p>

              {/* Bloc Signature */}
              <div className="signature-block anim-up delay-3">
                <span className="sig-name">Salah Eddine EL KACIMI, MRICS</span>
                <span className="sig-title">
                  Expert Immobilier MRICS - <span className="sig-title-mixed">Registered Valuer</span>
                </span>
                
                <ul className="sig-details">
                  <li>Ingénieur Topographe (IAV HASSAN II – Rabat)</li>
                  <li>Mastère en Droit et Fiscalité de l’Entreprise (ISCAE – Casablanca)</li>
                  <li>Enseignant des matières de l’immobilier dans différents programmes</li>
                </ul>
              </div>

            </div>

            {/* Colonne Droite : Image */}
            <div className="director-img-col anim-right delay-2">
              <div className="director-img-wrapper">
                <img src={directorImg} alt="Salah Eddine EL KACIMI - Directeur ATAA Realty" />
              </div>
            </div>

          </div>
        </div>
      </section>

      <Footer />
    </>
  );
};

export default MotDirecteur;